export default "__VITE_PUBLIC_ASSET__37a32559__"